import { BrowserRouter, Route, Routes } from "react-router-dom"
import { routingPages } from "./pages";
import { useFetchPrices } from "../app/containers/Raydium/hooks/useFetchPrices";

import { Buffer } from 'buffer';
import process from "process";

if (typeof window !== "undefined") {
    window.Buffer = Buffer;
    window.process = process;
}
const AppRoutes = () => {


    return (
        <BrowserRouter>
            {/* <Navbar/> */}
            <Routes >
                {
                    routingPages?.map(({ component: Component, path, children }, i) => {
                        if (children) {
                            return (
                                <Route exact key={i} path={path} element={<Component />} >
                                    {
                                        children?.map(({ component: Component, path, children }, i) => {
                                            if (children) {
                                                return (
                                                    <Route key={i} path={path} element={<Component />} >
                                                        {
                                                            children?.map(({ component: Component, path, children }, i) => <Route key={i} path={path} element={<Component />} />)
                                                        }
                                                    </Route>)
                                            } else {
                                                return <Route key={i} path={path} element={<Component />} />
                                            }
                                        })
                                    }
                                </Route>
                            )
                        } else {
                            return <Route key={i} path={path} element={<Component />} />
                        }
                    }
                    )
                }
            </Routes>
        </BrowserRouter>
    )
}

export default AppRoutes